(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hrs-popup-mobile-fix"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__hrsStorefrontControlsReady) return;
  window.__hrsStorefrontControlsReady = true;

  var POPUP_KEY = 'hrs_newsletter_popup_closed_until';
  var engaged = false;
  var observer;
  var intervalId;
  var updateFrame;

  document.documentElement.classList.add('hrs-popup-suppressed');

  function popupRoot() {
    return document.getElementById('popup');
  }

  function closeDays() {
    var root = popupRoot();
    var days = root ? parseInt(root.getAttribute('data-popup-time'), 10) : 7;
    return isNaN(days) || days < 1 ? 7 : days;
  }

  function isClosed() {
    var until = parseInt(window.localStorage.getItem(POPUP_KEY) || '0', 10);
    return Boolean(until && until > Date.now());
  }

  function markClosed() {
    var days = closeDays();
    window.localStorage.setItem(POPUP_KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
  }

  function isVisible(element) {
    if (!element) return false;
    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function cookieBannerVisible() {
    return isVisible(document.getElementById('shopify-pc__banner')) ||
      isVisible(document.getElementById('shopify-pc__prefs__dialog'));
  }

  function newsletterVisible() {
    if (document.documentElement.classList.contains('hrs-popup-suppressed')) return false;
    return isVisible(document.getElementById('slide-up')) ||
      isVisible(document.getElementById('fullscreen')) ||
      isVisible(document.getElementById('PopupOverlay'));
  }

  function forceHidePopup() {
    var elements = [
      popupRoot(),
      document.getElementById('slide-up'),
      document.getElementById('fullscreen'),
      document.getElementById('PopupOverlay')
    ];

    elements.forEach(function (element) {
      if (!element) return;
      element.style.display = 'none';
      element.style.visibility = 'hidden';
      element.setAttribute('aria-hidden', 'true');
      element.classList.remove('show', 'open', 'active', 'animate');
    });

    document.body.classList.remove('popup-open', 'modal-open', 'overflow-hidden');
  }

  function updateOverlayState() {
    var closed = isClosed();
    var consentOpen = cookieBannerVisible();
    var suppressPopup = closed || consentOpen || !engaged;

    document.documentElement.classList.toggle('hrs-popup-suppressed', suppressPopup);

    if (closed) {
      forceHidePopup();
    }

    window.requestAnimationFrame(function () {
      document.documentElement.classList.toggle(
        'hrs-support-hidden',
        cookieBannerVisible() || newsletterVisible()
      );
    });
  }

  function queueOverlayUpdate() {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateOverlayState();
    });
  }

  function checkScrollEngagement() {
    if (engaged) return;
    var pageHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    if (window.scrollY / pageHeight >= 0.3) {
      engaged = true;
      updateOverlayState();
    }
  }

  function exitIntent(event) {
    if (engaged || window.matchMedia('(max-width: 767px)').matches) return;
    if (!event.relatedTarget && event.clientY <= 0) {
      engaged = true;
      updateOverlayState();
    }
  }

  function closeHandler(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('.popup--close-btn, .popup--close')) {
      markClosed();
      window.setTimeout(forceHidePopup, 0);
      window.setTimeout(forceHidePopup, 100);
      window.setTimeout(forceHidePopup, 500);
      queueOverlayUpdate();
    }
  }

  function moveHowToVideos() {
    if (window.matchMedia('(max-width: 767px)').matches) return;

    var nav = document.getElementById('AccessibleNav');
    if (!nav) return;

    var shopBy;
    var howTo;

    Array.prototype.forEach.call(nav.children, function (item) {
      var directLink = item.querySelector(':scope > a');
      if (!directLink) return;

      var label = directLink.textContent.replace(/\s+/g, ' ').trim();
      if (label === 'Shop By') shopBy = item;
      if (directLink.getAttribute('href') === '/pages/how-to-videos') howTo = item;
    });

    if (!shopBy || !howTo) return;

    var dropdown = shopBy.querySelector(':scope > ul.site-nav__dropdown');
    var howToLink = howTo.querySelector(':scope > a');
    if (!dropdown || !howToLink) return;

    if (!dropdown.querySelector('a[href="/pages/how-to-videos"]')) {
      var dropdownItem = document.createElement('li');
      dropdownItem.appendChild(howToLink.cloneNode(true));
      dropdown.appendChild(dropdownItem);
    }

    howTo.remove();
  }

  function addPolicyFooterLink() {
    var footerList = document.querySelector('.footer-main .links-footer .footer-content');
    var sourceLink = document.querySelector('#NavDrawer a[href="/pages/our_policy"]');
    if (!footerList || !sourceLink) return;
    if (footerList.querySelector('a[href="/pages/our_policy"]')) return;

    var item = document.createElement('li');
    var link = document.createElement('a');
    var label = document.createElement('span');

    link.setAttribute('href', sourceLink.getAttribute('href'));
    label.className = 'animated-underline';
    label.textContent = sourceLink.textContent.replace(/\s+/g, ' ').trim();

    link.appendChild(label);
    item.appendChild(link);
    footerList.appendChild(item);
  }

  function start() {
    moveHowToVideos();
    addPolicyFooterLink();
    checkScrollEngagement();
    updateOverlayState();

    document.addEventListener('click', closeHandler, true);
    document.addEventListener('touchstart', closeHandler, true);
    document.addEventListener('pointerdown', closeHandler, true);
    document.addEventListener('mouseout', exitIntent);
    window.addEventListener('scroll', checkScrollEngagement, { passive: true });
    window.addEventListener('resize', function () {
      moveHowToVideos();
      queueOverlayUpdate();
    }, { passive: true });

    document.addEventListener('shopify:section:load', function () {
      moveHowToVideos();
      addPolicyFooterLink();
      queueOverlayUpdate();
    });

    observer = new MutationObserver(queueOverlayUpdate);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });

    intervalId = window.setInterval(updateOverlayState, 1000);
    window.setTimeout(function () {
      if (intervalId) window.clearInterval(intervalId);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hrs-review-shortcut"] && !Shopify.designMode) return;
  try {
    (() => {
  const enhanceReviewBadges = () => {
    const config = document.querySelector('.hrs-review-shortcut-config');

    if (!config) return;

    document.querySelectorAll('.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge').forEach((badge) => {
      const reviewCount = Number(badge.dataset.numberOfReviews || 0);

      if (!reviewCount || badge.querySelector('.hrs-review-shortcut')) return;

      const link = document.createElement('a');
      link.className = 'hrs-review-shortcut';
      link.href = '#judgeme_product_reviews';
      link.textContent = config.dataset.label || 'Read customer reviews';
      link.addEventListener('click', (event) => {
        const reviewSection = document.querySelector('#judgeme_product_reviews');

        if (!reviewSection) return;

        event.preventDefault();
        event.stopPropagation();
        reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', '#judgeme_product_reviews');
      });
      badge.appendChild(link);
    });
  };

  enhanceReviewBadges();

  const observer = new MutationObserver(enhanceReviewBadges);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
  document.addEventListener('shopify:section:load', enhanceReviewBadges);
})();
  } catch(e) { console.error(e); }
})();

})();
